import { makeStyles } from '@material-ui/core/styles';
import VisibilityIcon from '@material-ui/icons/Visibility';

interface Props {
  onClick: () => void;
}

const useStyles = makeStyles(() => ({
  icon: {
    marginRight: '8px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const FieldVisibilityOn = (props: Props) => {
  const classes = useStyles();
  const { onClick } = props;

  return (
    <VisibilityIcon
      className={classes.icon}
      color="action"
      fontSize="small"
      onClick={() => onClick()} />
  );
};

export default FieldVisibilityOn;
